<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">{{ 'NOTIFICATIONS.NOTIFICATIONS_LIST.TITLE' | translate }}</h5>
    </div>
    <div class="col-auto ms-auto">
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>

      <!--      <button type="button" class="btn btn-secondary" aria-label="Add" (click)="export()">-->
      <!--        {{ 'LOCALES.LOCALES_LIST.EXPORT' | translate }}-->
      <!--      </button>-->
    </div>
  </div>
  <kendo-grid
    [data]="data"
    [pageSize]="notificationsResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Notifications', grid)"
  >
    <kendo-grid-column
      field="number"
      [filterable]="false"
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'NOTIFICATIONS.NOTIFICATIONS_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <!--<kendo-grid-column
      field="reminderable_id"
      title="{{ 'NOTIFICATIONS.NOTIFICATIONS_LIST.REMINDABLE_ID' | translate }}"
      class="text-center"
      headerClass="text-center"
      [width]="70"
      [hidden]="isHiddenColumn('reminderable_id')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.notifiable_id }}
      </ng-template>
    </kendo-grid-column>-->

    <kendo-grid-column
      field="notifiable_type"
      [width]="200"
      title="{{ 'NOTIFICATIONS.NOTIFICATIONS_LIST.TYPE' | translate }}"
      [hidden]="isHiddenColumn('notifiable_type')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.cleanNotifiableType }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="data->message"
      title="{{ 'NOTIFICATIONS.NOTIFICATIONS_LIST.MESSAGE' | translate }}"
      [hidden]="isHiddenColumn('notification.data.message')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.text }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="read_at"
      title="{{ 'NOTIFICATIONS.NOTIFICATIONS_LIST.READ_DATE' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('read_at')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.read_at | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="created_at"
      title="{{ 'NOTIFICATIONS.NOTIFICATIONS_LIST.CREATED_AT' | translate }}"
      filter="date"
      [width]="300"
      [hidden]="isHiddenColumn('created_at', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.created_at.getDate() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="read_at_bool"
      title="{{ 'NOTIFICATIONS.NOTIFICATIONS_LIST.IS_READ' | translate }}"
      filter="boolean"
      [sortable]="false"
      [width]="100"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('read_at_bool')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="!!dataItem.read_at"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'REMINDERS.REMINDERS_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <button
          class="btn btn-success btn-ico"
          container="body"
          *ngIf="!dataItem.read_at"
          [ngbTooltip]="'NOTIFICATIONS.MARK_AS_READ' | translate"
          (click)="markAsRead(dataItem)"
        >
          <i class="far fa-check" class="far fa-check"></i>
        </button>
        <a
          class="btn btn-warning btn-ico"
          container="body"
          target="_blank"
          [href]="dataItem.link"
          *ngIf="dataItem.link"
          [ngbTooltip]="'NOTIFICATIONS.GO_TO_TARGET' | translate"
        >
          <i class="fal fa-external-link"></i>
        </a>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
